/**
 * English: Search + device_type filter for agent management list views.
 * Thai: ค้นหาและกรองประเภทอุปกรณ์สำหรับรายการ agent management
 */
import { useMemo, useState } from 'react';
import type { AgentRow } from './useAgentRows';

export function useAgentManagementFilters(rows: AgentRow[]) {
  const [search, setSearch] = useState('');
  const [typeFilter, setTypeFilter] = useState('');

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    return rows.filter((r) => {
      const type = (r.device?.device_type || (r.agent.role as string) || '').toLowerCase();
      if (typeFilter && type !== typeFilter.toLowerCase()) return false;
      if (!q) return true;
      const name = String(r.agent.name || '').toLowerCase();
      const id = r.agent.id.toLowerCase();
      const did = r.deviceId.toLowerCase();
      const dm = r.device?.device_manage;
      const cmmsName = dm?.device_manage_name != null ? String(dm.device_manage_name).toLowerCase() : '';
      const cmmsMfr = dm?.manufacturer != null ? String(dm.manufacturer).toLowerCase() : '';
      const cmmsCode = dm?.cmms_device_code != null ? String(dm.cmms_device_code).toLowerCase() : '';
      return (
        id.includes(q) ||
        did.includes(q) ||
        name.includes(q) ||
        cmmsName.includes(q) ||
        cmmsMfr.includes(q) ||
        cmmsCode.includes(q)
      );
    });
  }, [rows, search, typeFilter]);

  return { search, setSearch, typeFilter, setTypeFilter, filtered };
}
